import React from "react";
import "./EventList.scss";
import "../../../../components/Search/Search.scss";
import Pagination from "../../../../components/Pagination/Pagination";
import useEventList from "./logic/useEventList";
import EventCard from "../EventCard/EventCard";
import { checkUserRole } from "../../../../core/utils/helpers";
import useAuth from "../../../../core/hooks/useAuth";
import AddCard from "../../../../components/AddCard/AddCard";
import CreateEventModal from "../../CreateEventModal/CreateEventModal";
import { Input, Spin } from "antd";

function EventList({includeUpcoming, nameSection }) {
  const {
    data,
    handleSearchChange,
    eventImages,
    meta,
    searchRef,
    handleDeleteEvent,
    cancel,
    isModalOpen,
    setIsModalOpen,
    handleNext,
    handlePrevious,
    isFetchingEvents
  } = useEventList(includeUpcoming);
 const { authenticatedUser } = useAuth ();

 const openModal = () => {
  setIsModalOpen(true);
};

  return (
    <div className="list-event">
      <div className="flexbox">
        <div className="search-container">
          <Input.Search
            placeholder="Search..."
            onChange={handleSearchChange}
            style={{ width: "300px" }}
            className="search-input"
            ref={searchRef}
          />
        </div>
      </div>

      <div className="spinnerStyle">
        <Spin
          spinning={isFetchingEvents}
          size="large"
          style={{ marginTop: "30px" }}
        />
      </div>

      <div className="card-list">
     { checkUserRole(authenticatedUser, ["Admin", "Trainer"],
      <AddCard Mode="Event"
          className="open-modal-button"
          openModal={openModal}
           />) }
        <CreateEventModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          includeUpcoming={includeUpcoming}
        />
        {data?.map((card, index) => (
          <EventCard
            className="card"
            key={index}
            {...card}
            eventImage={eventImages[index]}
            handleDeleteEvent={handleDeleteEvent}
            nameSection={nameSection}
            cancel={cancel}
            includeUpcoming={includeUpcoming}

          />
        ))}
      </div>

      <Pagination
        hasNextPage={meta.hasNextPage}
        hasPreviousPage={meta.hasPreviousPage}
        handleNext={handleNext}
        handlePrevious={handlePrevious}
        currentPage={meta?.page}
        totalPageCount={meta?.pageCount}
      />
    </div>
  );
}

export default EventList;
